/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Announcement } from '../../models/announcement';
import { KeyType } from '../../models/key-type';
import { PatchAnnouncementRequest } from '../../models/patch-announcement-request';

export interface PatchServiceProviderAnnouncement$Params {

/**
 * The announcement key
 */
  announcementKey: KeyType;
      body: PatchAnnouncementRequest
}

export function patchServiceProviderAnnouncement(http: HttpClient, rootUrl: string, params: PatchServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
  const rb = new RequestBuilder(rootUrl, patchServiceProviderAnnouncement.PATH, 'patch');
  if (params) {
    rb.path('announcementKey', params.announcementKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Announcement>;
    })
  );
}

patchServiceProviderAnnouncement.PATH = '/service-provider/announcements/{announcementKey}';
